// Events
export const EVENT_CLICKED_INVITE_BUTTON = 'Clicked Find Designer Invite Button';

// Designer levels
export const LEVEL_ENTRY = 'entry';
export const LEVEL_MID = 'mid';
export const LEVEL_TOP = 'top';

// Designer level map
interface DesignerLevelMapping {
    [key: string]: string;
}

export const LEVEL_MAP : DesignerLevelMapping = {
    'top-level': LEVEL_TOP,
    'mid-level': LEVEL_MID,
    'entry-level': LEVEL_ENTRY
}

// Search defaults
export const SEARCH_FROM = 0;
export const SEARCH_SIZE = 30;
export const MAX_RESULTS = 3000;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/consts.ts